import { usePageMeta } from './usePageMeta';

export { SITE_NAME } from './usePageMeta';

/**
 * @deprecated Prefer usePageMeta for title + SEO tags. Kept for simple title-only pages.
 */
export function useDocumentTitle(title) {
  usePageMeta({ title: title || undefined });
}

export default useDocumentTitle;
